export const GET_NEW_ARR_PRODUCT = "GET_NEW_ARR_PRODUCT";
export const CLEAR_NEW_ARR_PRODUCT = "CLEAR_NEW_ARR_PRODUCT";

